import type { GridFilterOperator } from '@zoryn/components/grid'
import type { RuleColumnType, SystemParamField } from './rules'

export const LOGIC_OPTIONS = [
  { value: 'and', label: 'z.table.logic.and' },
  { value: 'or', label: 'z.table.logic.or' },
] as const

const TEXT_OPERATORS: Array<{ value: GridFilterOperator; label: string }> = [
  { value: 'eq', label: 'z.table.operator.eq' },
  { value: 'ne', label: 'z.table.operator.ne' },
  { value: 'like', label: 'z.table.operator.like' },
  { value: 'notLike', label: 'z.table.operator.notLike' },
  { value: 'empty', label: 'z.table.operator.empty' },
  { value: 'notEmpty', label: 'z.table.operator.notEmpty' },
]

const NUMBER_DATE_OPERATORS: Array<{ value: GridFilterOperator; label: string }> = [
  { value: 'eq', label: 'z.table.operator.eq' },
  { value: 'ne', label: 'z.table.operator.ne' },
  { value: 'gt', label: 'z.table.operator.gt' },
  { value: 'ge', label: 'z.table.operator.ge' },
  { value: 'lt', label: 'z.table.operator.lt' },
  { value: 'le', label: 'z.table.operator.le' },
  { value: 'empty', label: 'z.table.operator.empty' },
  { value: 'notEmpty', label: 'z.table.operator.notEmpty' },
]

const SWITCH_OPERATORS: Array<{ value: GridFilterOperator; label: string }> = [
  { value: 'eq', label: 'z.table.operator.eq' },
  { value: 'ne', label: 'z.table.operator.ne' },
]

export function getRuleOperator(type: RuleColumnType) {
  if (type === 'number' || type === 'date') {
    return NUMBER_DATE_OPERATORS.map((item) => ({ ...item }))
  }
  if (type === 'switch') {
    return SWITCH_OPERATORS.map((item) => ({ ...item }))
  }
  return TEXT_OPERATORS.map((item) => ({ ...item }))
}

const COLUMN_TYPE_MAP: Record<string, RuleColumnType> = {
  输入框: 'input',
  值类型: 'lov',
  表格: 'table',
  复选框: 'switch',
  input: 'input',
  number: 'number',
  date: 'date',
  lov: 'lov',
  table: 'table',
  switch: 'switch',
  checkbox: 'switch',
}

export function resolveRuleColumnType(columnType: string): RuleColumnType {
  return COLUMN_TYPE_MAP[columnType] ?? 'input'
}

export function toRuleFieldMeta(field: SystemParamField) {
  const type = resolveRuleColumnType(field.columnType)
  return {
    field: field.field,
    title: field.name,
    type,
    dataSource: field.dataSource,
  }
}
